export enum ConnectionResult {
  NO_ATTEMPT,
  INVALID_LOGIN,
  CANT_READ,
}
